import { useEffect, useState } from "react";
import { SelectToPrintCardProps } from "../../models/GenericCardProps";
import RefreshDocsDialog from "./RefreshDocsDialog";
import { IDocListItem, IDocListResponse } from "../../models/IDocListResponse";
import SelectToPrintModal from "./SelectToPrintModal";
import ErrorModal from "./ErrorModal";
import { IConformXErrors } from "../../models/IDocGenStatusModel";
import ConfirmationDialog from "../shared/ConfirmDialog";
import {
    StyledCard,
    StyledCardHeader,
    StyledCardContent,
    StyledList,
    StyledListItem,
    StyledListItemText,
    StyledCardActions,
    ActionButton,
    ClearButton
} from './SelectToPrintCard.styles';

function SelectToPrintCard(props: SelectToPrintCardProps) {
    const [confirmUpdateOpen, setConfirmUpdateOpen] = useState<boolean>(false);
    const [selectDocsModalOpen, setSelectDocsModalOpen] = useState<boolean>(false);
    const [docErrors, setDocErrors] = useState<IConformXErrors | null>(null);
    const [docErrorOpen, setDocErrorOpen] = useState<boolean>(false);
    const [enableButton, setEnableButton] = useState<boolean>(false);
    const [enableClearButton, setEnableClearButton] = useState<boolean>(false);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

    const cardVisibility = () => {
        if (props.visible)
            return 'flex';
        return 'none';
    }

    //handle the updated document list; used in update dialog
    //should show errors when applicable
    const handleUpdatedDocuments = (response: IDocListResponse) => {
        if (response.result.conformXResponse?.errors) {
            setDocErrors(response.result.conformXResponse!.errors);
            setDocErrorOpen(true);
        }

        if (response.result.conformXResponse?.documentList?.documents && response.result.conformXResponse?.documentList?.documents?.length > 0) {
            props.setListMethod(response.result.conformXResponse.documentList.documents);
            setSelectDocsModalOpen(true);
            props.setSelectedListMethod([]);
        }
    }

    //close the errors dialog
    const handleErrorDialogClose = () => {
        setDocErrors(null);
        setDocErrorOpen(false);
    }

    //close the select docs dialog
    const handleCloseDocsModal = () => {
        setSelectDocsModalOpen(false)
    }

    //close the confirmation dialog
    const handleConfirmClose = async (ok: boolean) => {
        if (ok) {
            setSelectDocsModalOpen(true);
        }
        setConfirmUpdateOpen(false);
    }

    //clicking select to Print Button
    const handleSelectToPrintButton = () => {
        if (props.docList.length <= 1) {
            handleSelectDocument([]);
            setConfirmUpdateOpen(true);
        }
        else {
            setSelectDocsModalOpen(true);
        }
    }

    //update selected list
    const handleSelectDocument = (docs: Array<IDocListItem>) => {
        props.setSelectedListMethod(docs);
    }

    //clear button
    const handleClearSelectedButton = () => {
        props.setSelectedListMethod([]);
        setConfirmDialogOpen(false);
    }

    //setting clear button enabled
    useEffect(() => {
        if (props.selectedDocList.length > 0) {
            setEnableClearButton(true)
        } else
            setEnableClearButton(false);
    }, [props.selectedDocList.length])

    //setting button enabled
    useEffect(() => {
        if (props.packageId && props.enabled) {
            setEnableButton(true)
        } else
            setEnableButton(false);
    }, [props.packageId, props.enabled])

    return (
        <>
            <StyledCard 
                style={{ 
                    display: cardVisibility() 
                }}>
                <StyledCardHeader 
                    title={`${((props.title && props.title !== "") ? props.title : "Select to Print")} ${props.selectedDocList.length}/${props.docList.length} `}>
                </StyledCardHeader>
                <StyledCardContent>
                    <StyledList>
                        {props.selectedDocList.map((doc) => {
                            return (
                                <StyledListItem 
                                    key={doc.documentIndex + '_' + doc.primaryInstanceId}
                                    disablePadding
                                >
                                    <StyledListItemText 
                                        primary={doc.name}
                                    />
                                </StyledListItem>
                            )
                        })}
                    </StyledList>
                </StyledCardContent>
                <StyledCardActions>
                    <ActionButton 
                        variant="contained" 
                        size="small" 
                        disabled={!enableButton} 
                        onClick={handleSelectToPrintButton}>
                        Select to Print
                    </ActionButton>
                    <ClearButton 
                        variant="contained" 
                        size="small" 
                        color="error" 
                        disabled={!enableClearButton} 
                        onClick={() => setConfirmDialogOpen(true)}>
                        Clear
                    </ClearButton>
                </StyledCardActions>
            </StyledCard>
            <RefreshDocsDialog
                confirmUpdateOpen={confirmUpdateOpen}
                handleConfirmClose={handleConfirmClose}
                packageId={props.packageId ?? ""}
                altPackageId={props.altPackageId ?? ""}
                parentPackageId={props.parentPackageId ?? ""}
                handleUpdatedDocs={handleUpdatedDocuments}
            />
            <SelectToPrintModal
                selectDocsModalOpen={selectDocsModalOpen}
                openRefreshConfirm={() => { setConfirmUpdateOpen(true); }}
                handleClose={handleCloseDocsModal}
                documentList={props.docList}
                selectedDocumentList={props.selectedDocList}
                setSelectedDocumentList={handleSelectDocument}
            />
            <ErrorModal
                title="Errors fetching document list"
                errors={docErrors}
                modalOpen={docErrorOpen}
                handleModalClose={handleErrorDialogClose}
            />
            <ConfirmationDialog
                open={confirmDialogOpen}
                title={"Confirm Reset of Select to Print List"}
                message={"Are you sure  you want to clear this list?"}
                subMessage="Doing so will require a re-fetch to repopulate this list."
                onConfirm={handleClearSelectedButton}
                onCancel={() => setConfirmDialogOpen(false)} />
        </>
    )
}
export default SelectToPrintCard;